import { CommonModule, NgClass } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { LocalStorageService } from '../../../services/local-storage.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { adminEnvironment } from '../../../../environments/environment';
import { AdminAuthService } from '../service/admin-auth.service';
import { MatRippleModule } from '@angular/material/core';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-side-bar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, NgClass, CommonModule, MatRippleModule],
  templateUrl: './side-bar.component.html',
  styleUrl: './side-bar.component.scss'
})
export class SideBarComponent {
  public admin_logged_in = false;
  public collapsed = false;
  public isPlatformAdmin = false;
  public isTenantAdmin = false;
  isPlatformAdmin$!: Observable<boolean>;
  isTenantAdmin$!: Observable<boolean>;

  @Output() sidebarCollapsed = new EventEmitter<boolean>();

  constructor(private router: Router, private localStorage: LocalStorageService, private oidcSecurityService: OidcSecurityService, private authService: AdminAuthService) {
    this.isPlatformAdmin$ = this.authService.platformAdmin$;
    this.isTenantAdmin$ = this.authService.tenantAdmin$;
  }
  async ngOnInit() {
    this.authService.adminUserInfo$.subscribe((userInfo) => {
      this.admin_logged_in = !!userInfo.userName;
      console.log(`[SideBar] admin_logged_in =`, this.admin_logged_in);
    });
    this.isPlatformAdmin = await this.authService.isPlatformAdmin();
    this.isTenantAdmin = await this.authService.isTenantAdmin();

    this.localStorage.setItem("is_admin", "true");
    console.log(`init sidebar`);

    const savedState = localStorage.getItem('sidebar_collapsed');
    this.collapsed = savedState === 'true';
    this.sidebarCollapsed.emit(this.collapsed);
  }


  toClientPortal() {
    this.localStorage.setItem("is_admin", "false");
    this.router.navigate(['/dashboard']);
  }

  signIn(): void {
    this.oidcSecurityService.authorize();
  }

  signOut(): void {
    if (window.sessionStorage) {
      window.sessionStorage.clear();
    }

    this.authService.logout();

    setTimeout(() => {
      window.location.href = `${adminEnvironment.aws.cognito.oauth.logout_domain}/logout?client_id=${adminEnvironment.aws.cognito.userPoolWebClientId}&logout_uri=${adminEnvironment.aws.cognito.oauth.redirectSignOut}`;
    }, 100);
  }


  toggleCollapse() {
    this.collapsed = !this.collapsed;
    localStorage.setItem('sidebar_collapsed', String(this.collapsed));
    this.sidebarCollapsed.emit(this.collapsed);
  }

}
